import { SAS_TOKEN_ENDPOINT } from "../constants";
import { SasTokenResponse } from "../types";
import logger from "../Log";

export class DownloadService {
  static async downloadFile(sasUrl: string, fileName: string): Promise<void> {
    window.open(sasUrl, "_blank");
    logger.info(`Opened URL for file: ${fileName}`);
  }

  static async getAssetInfoByObjectId(
    objectId: string
  ): Promise<SasTokenResponse> {
    const endpoint = `${SAS_TOKEN_ENDPOINT}-by-objectid?objectId=${encodeURIComponent(
      objectId
    )}`;

    logger.info(`Requesting asset info for objectId: ${objectId}`);

    const response = await fetch(endpoint);
    if (!response.ok) {
      throw new Error(`Failed to get asset info: ${response.status}`);
    }

    const data: SasTokenResponse = await response.json();
    if (!data.assetInfo) {
      throw new Error("No asset info in response");
    }

    return data;
  }

  static async getSasUrlByObjectIdAndDownload(objectId: string): Promise<void> {
    try {
      const data = await DownloadService.getAssetInfoByObjectId(objectId);

      if (data.sasUrl && data.assetInfo) {
        logger.info("SAS URL received, starting download...");
        await DownloadService.downloadFile(
          data.sasUrl,
          data.assetInfo.fileName
        );
      } else {
        throw new Error("No SAS URL in response");
      }
    } catch (err) {
      logger.error("Error handling asset download: ", err);
    }
  }

  // Keep the old method for backward compatibility if needed
  static async getSasUrlAndDownload(
    containerName: string,
    blobName: string
  ): Promise<void> {
    try {
      const endpoint = `${SAS_TOKEN_ENDPOINT}?containerName=${encodeURIComponent(
        containerName
      )}&blobName=${encodeURIComponent(blobName)}`;

      logger.info(
        `Requesting SAS URL for container: ${containerName}, blob: ${blobName}`
      );

      const response = await fetch(endpoint);
      if (!response.ok) {
        throw new Error(`Failed to get SAS token: ${response.status}`);
      }

      const data = await response.json();
      if (data.sasUrl) {
        logger.info("SAS URL received, starting download...");
        await DownloadService.downloadFile(data.sasUrl, blobName);
      } else {
        throw new Error("No SAS URL in response");
      }
    } catch (err) {
      logger.error("Error handling asset download: ", err);
    }
  }
}
